<template>
    <div style="margin: 0 auto; padding-top: 0.7rem;padding-bottom: .24rem;background-color: #FFF;">
        <div style="display: flex;justify-content: center;flex-direction: column;align-items: center;">
            <div><img style="width: .48rem;height: .48rem;" src="@/assets/3.png" alt="" srcset=""></div>
            <div style=" font-size: 14px; font-weight: 400;margin-top: .16rem;"><span>下单成功，您的订单可在个人中心—我的课程查看</span></div>
        </div>
        <div
            style="background: #F2F3F5;border-radius: 8px;padding: .24rem;margin-top: .4rem;display: flex;align-items: center;">
            <div style="flex: 1;">
                <div style=" color: #333333; font-size: 14px;"><span>{{ detailData.title }}</span></div>
                <div style=" color: #86909c; font-size: 12px;margin-top: 8px;">
                    <span>{{ detailData.content }}</span>
                </div>
            </div>
            <div style="display: flex;column-gap: 1.58rem;">
                <div style="color: #333333; font-size: 14px;"><span>{{ detailData.type == 1 ? '线上课程' : '线下课程' }}</span>
                </div>
                <div style="color: #333333;font-size: 14px;"><span>￥{{ detailData.price }}</span></div>
            </div>
        </div>
        <div style="margin-top: .16rem;display: flex;flex-direction: column;row-gap: .16rem;">
            <div style="display: flex;justify-content: space-between;align-items: center;">
                <div style=" color: #86909c; font-size: 14px;"><span>商品价格：</span></div>
                <div style="  color: #333333; font-size: 14px;"><span>￥{{ detailData.price }}</span></div>
            </div>
            <div style="display: flex;justify-content: space-between;align-items: center;">
                <div style=" color: #86909c; font-size: 14px;"><span>商品数量：</span></div>
                <div style="  color: #333333; font-size: 14px;"><span>x1</span></div>
            </div>
            <div style="display: flex;justify-content: space-between;align-items: center;">
                <div style=" color: #86909c; font-size: 14px;"><span>合计：</span></div>
                <div style="  color: #333333; font-size: 14px;"><span>￥{{ detailData.price }}</span></div>
            </div>
        </div>
        <div style="display: flex;justify-content: center;align-items: center;column-gap: .24rem;margin-top: .4rem;">
            <div @click="$router.push('/ShadowTrainDetailPage?id=' + urlData.get('id'))"
                style="width: 1.36rem;height: .45rem;background: #C01A26;border-radius: .08rem; color: #ffffff;text-align: center;line-height: .45rem;cursor: pointer;">
                <span>返回</span>
            </div>
            <div @click="$router.push('/myCourse?id=' + urlData.get('id'))"
                style="width: 1.36rem;height: .45rem;border-radius: .08rem; color: #000;text-align: center;line-height: .45rem;border: 1px solid #86909C;cursor: pointer;">
                <span>查看订单</span>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref } from 'vue'
import { Axios } from "../../assets/js/ls_com_axios.js";
defineProps(['orderData']);
const urlData = new URLSearchParams(location.search);
const detailData = ref({});
const getList = () => {
    // loading.value = true;
    Axios(
        "get",
        "/system/courseWeb/catalogue",
        {
            courseId: urlData.get('id')
        },
        false,
        (res) => {
            detailData.value = res.data.data;
            // loading.value = false;
        },
        () => {
            // loading.value = false;
            detailData.value = {};
        })
}
getList()
</script>